const otpEndpoints = {
  sendSignupOtp: { method: "POST", path: "/otp/signup" },
  sendResetPasswordOtp: { method: "POST", path: "/otp/reset-password" },
};

export default otpEndpoints;
